<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            ວຽກງານ ICS ຂັ້ນ{{  section}}
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 26 || roleid == 27 ||  roleid == 28">
        <b-tab-item label="ຂັ້ນເມືອງ" >
          <div class="columns scrollme" v-if="roleid == 26">
            <div class="column">
              <b-field label="ລາຍການຂັ້ນເມືອງ" >
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="20%">
                        ຊື່ເມືອງ 
                      </th>
                      <th class="has-text-centered " width="30%">
                        ຈຳນວນກຸ່ມ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນສະມາຊິກ
                      </th>
                      <th class="has-text-centered " width="20%">
                        ເລືອກເມືອງ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in districtList" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td  >
                        {{ data.DISTRICTNAME }}
                      </td>
                      <td  class="has-text-centered">
                        {{ data.NUMOFGROUP  }}
                      </td>
                      <td  class="has-text-centered">
                        {{ data.NUMOFFARM  }}
                      </td>

                      <td class="has-text-centered">
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="
                              getIcsGroup(data)
                            "
                            >ເລືອກເມືອງ
                          </b-button>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ຂັ້ນກຸ່ມ">
          <b-field v-if="!isDistrictSelected" >
            <button class="button is-info" @click="gotoDistrictlist" v-if="roleid == 26">
              ເລືອກເມືອງ
            </button>
          </b-field>
          <b-field v-else>
            <div class="columns scrollme">
              <div class="column">
                <b-field :label="selectedDistrictName">
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="40%">
                          ຊື່ກຸ່ມ
                        </th>
                        <th class="has-text-centered " width="15%">
                          ຈຳນວນສະມາຊິກ
                        </th>
                        <th class="has-text-centered " width="20%">
                          ຈັດການ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in groupList" :key="data.ID">
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td  >
                          {{ data.GROUPNAME }}
                        </td>
                        <td  class="has-text-centered">
                          {{ data.NUMOFFARM  }}
                        </td>

                        <td class="has-text-centered">
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                getIcsFarm(data)
                              "
                              >ເລືອກກຸ່ມ 
                            </b-button>
                          </b-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-field>
              </div>
            </div>
          </b-field>
          
        </b-tab-item>

        <b-tab-item label="ຊາວກະສິກອນ">
          
          <b-field v-if="!isGroupSelected">
            <button class="button is-info" @click="gotoGrouplist">
              ເລືອກກຸ່ມ
            </button>
          </b-field>
          <b-field v-else>
            <div class="columns scrollme">
              <div class="column">
                <b-field :label="selectedGroupName">
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="30%">
                          ຊື່ຟາມ/ ເບີໂທ
                        </th>
                        <th  width="30%">
                          ຊື່ເຈົ້າຂອງ/ ເບີໂທ
                        </th>
                        <th  class="has-text-centered" width="15%">
                          ຜະລິດຕາມຕະຫຼາດ
                        </th>
                        <th   class="has-text-centered" width="15%">
                          ຜະລິດຕາມສັນຍາ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in farmList" :key="data.ID">
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td  >
                          {{ data.FARMNAME }} / {{ data.FARMPHONENO }}
                        </td>
                        <td  >
                          {{ data.OWNERNAME  }} / {{ data.OWNERPHONENO }}
                        </td>
                        <td   class="has-text-centered">
                          

                            <b-field  v-if="data.NUMOFMARKETPRODUCTION>0">
                              <b-button
                                class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  getIcsProduction(data,1)
                                "
                                >{{ data.NUMOFMARKETPRODUCTION  | formatNumberLocal}} 
                              </b-button>
                          </b-field>
                          <b-field  v-else>
                           -
                          </b-field>
                          
                        </td>
                        <td   class="has-text-centered">
                          <b-field  v-if="data.NUMOFCONTRACTPRODUCTION>0">
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                getIcsProduction(data,2)
                              "
                              >{{ data.NUMOFCONTRACTPRODUCTION  | formatNumberLocal}} 
                            </b-button>
                          </b-field>
                          <b-field  v-else>
                           -
                          </b-field>
                        </td>

                       
                      </tr>
                    </tbody>
                  </table>
                </b-field>
              </div>
            </div>

          </b-field>
        </b-tab-item>
        <b-tab-item label="ການຜະລິດ">
          
          <b-field v-if="!isProductionTypeSelected">
            <button class="button is-info" @click="gotoFarmlist">
              ເລືອກຟາມ
            </button>
          </b-field>
          <b-field v-else>
            <div class="columns scrollme">
              <div class="column">
                <b-field :label="selectedFarmName">
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="10%">
                          ລະຫັດຜະລິດ
                        </th>
                        <th  width="15%">
                          ພືດ
                        </th>
                        <th  width="10%">
                          ຈຳນວນຂຶ້ນແຜນ
                        </th>
                        <th  width="20%">
                          ມື້ຜະລິດ
                        </th>
                        <th  width="20%">
                          ມື້ເກັບກ່ຽວ
                        </th>
                        <th  width="10%">
                          ຈຳນວນເກັບກ່ຽວ
                        </th>
                        <th  width="10%" class="has-text-centered ">
                          ສະຖານະ ການຜະລິດ
                        </th>
                        <th  width="10%" class="has-text-centered ">
                          ມາດຕະຖານ ICS
                        </th>
                        <th class="has-text-centered " width="20%">
                          ລາຍລະອຽດ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in productionList" :key="data.MARKETPRODUCTIONID">
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td  >
                          {{ data.MARKETPRODUCTIONID_MASK }}
                        </td>
                        <td  >
                          {{ data.PRODUCTNAME }}
                        </td>
                        <td  >
                          {{ data.AMOUNT | formatNumberLocal}}
                        </td>
                        <td  >
                          {{ data.PRODUCEDATE }}
                        </td>
                        <td  >
                          {{ data.HARVESTDATE }}
                        </td>
                        <td  >
                          {{ data.HARVESTAMOUNT | formatNumberLocal}}
                        </td>
                        <td  class="has-text-centered ">
                          <b-field  v-if="data.STATUS==2" class="statusLabel-gray">
                            ຂຶ້ນແຜນແລ້ວ
                          </b-field>
                          <b-field  v-if="data.STATUS==3" class="statusLabel-green">
                            ກຳລັງຜະລິດ
                          </b-field>
                          <b-field  v-if="data.STATUS==4 " class="statusLabel-yellow">
                            ເກັບກ່ຽວແລ້ວ
                          </b-field>
                        </td>
                        <td  class="has-text-centered ">
                          <b-field  v-if="data.ICSRECORESTATUS==0" class="statusLabel-warning">
                            ບໍ່ຜ່ານ
                          </b-field>
                          <b-field  v-if="data.ICSRECORESTATUS==1 " class="statusLabel-passed">
                            ຜ່ານ
                          </b-field>
                        </td>

                        <td class="has-text-centered">
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                getIcsProductionDetail(data)
                              "
                              >ລາຍລະອຽດ
                            </b-button>
                          </b-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-field>
              </div>
            </div>

          </b-field>
        </b-tab-item>

        <b-tab-item label="ລາຍລະອຽດ">
          
          <div v-if="!isProductionDetailSelected">
            <button class="button is-info" @click="gotoProductionlist">
              ເລືອກຮອບການຜະລິດ
            </button>
          </div>
          <div v-else>

              <div class="columns " >
                <div class="column">
                  <table  width="100%" class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="10%">
                          ລະຫັດຜະລິດ
                        </th>
                        <th  width="15%">
                          ພືດ
                        </th>
                        <th  width="10%">
                          ຈຳນວນຂຶ້ນແຜນ
                        </th>
                        <th  width="20%">
                          ມື້ຜະລິດ
                        </th>
                        <th  width="20%">
                          ມື້ເກັບກ່ຽວ
                        </th>
                        <th  width="10%">
                          ຈຳນວນເກັບກ່ຽວ
                        </th>
                        <th  width="10%" class="has-text-centered ">
                          ສະຖານະ ການຜະລິດ
                        </th>
                        <th  width="10%" class="has-text-centered ">
                          ມາດຕະຖານ ICS
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in productionSelected" :key="data.MARKETPRODUCTIONID">
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td  >
                          {{ data.MARKETPRODUCTIONID_MASK }}
                        </td>
                        <td  >
                          {{ data.PRODUCTNAME }}
                        </td>
                        <td  >
                          {{ data.AMOUNT | formatNumberLocal}}
                        </td>
                        <td  >
                          {{ data.PRODUCEDATE }}
                        </td>
                        <td  >
                          {{ data.HARVESTDATE }}
                        </td>
                        <td  >
                          {{ data.HARVESTAMOUNT | formatNumberLocal}}
                        </td>
                        <td  class="has-text-centered ">
                          <b-field  v-if="data.STATUS==2" class="statusLabel-gray">
                            ຂຶ້ນແຜນແລ້ວ
                          </b-field>
                          <b-field  v-if="data.STATUS==3" class="statusLabel-green">
                            ກຳລັງຜະລິດ
                          </b-field>
                          <b-field  v-if="data.STATUS==4 " class="statusLabel-yellow">
                            ເກັບກ່ຽວແລ້ວ
                          </b-field>
                        </td>
                        <td  class="has-text-centered ">
                          <b-field  v-if="data.ICSRECORESTATUS==0" class="statusLabel-warning">
                            ບໍ່ຜ່ານ
                          </b-field>
                          <b-field  v-if="data.ICSRECORESTATUS==1 " class="statusLabel-passed">
                            ຜ່ານ
                          </b-field>
                        </td>

                       
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div> 
              <br>
             
              <div class="columns" >
                <div class="column">
                  ລາຍລະອຽດປັດໃຈການຜະລິດ
                  <table width="100%" class="table ">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="40%">
                          ຫົວຂໍ້
                        </th>
                        <th class="has-text-left " width="15%">
                          ລາຍການ
                        </th>
                        <th class="has-text-centered " width="10%">
                          ວັນທີ
                        </th>
                        <th class="has-text-centered " width="10%">
                          ຈຳນວນ
                        </th>
                        <th class="has-text-left " width="10%">
                          ລາຍລະອຽດ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in oarecordlist" :key="data.ID">
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td  >
                          {{ data.TITLE }}
                        </td>
                        <td  >
                          {{ data.ITEMNAME }}
                        </td>
                        <td class="has-text-centered ">
                          {{ data.DATEUSED}}
                        </td>
                        <td  class="has-text-centered ">
                          {{ data.AMOUNT }} {{ data.UNIT }}
                        </td>
                        <td  >
                          {{ data.DETAIL }}
                        </td>
                        
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <br>
              <div class="columns" >
                <div class="column">
                  ການບັນທຶກແຕ່ລະຂັ້ນ
                  <table width="100%" class="table ">
                    <thead>
                      <tr>
                        <th class="has-text-left " width="10%">
                          ຂັ້ນ
                        </th>
                        <th class="has-text-centered " width="15%">
                          ວັນທີ
                        </th>
                        <th class="has-text-centered " width="10%">
                          ສະຖານະ
                        </th>
                        <th class="has-text-left " width="70%">
                          ລາຍລະອຽດ
                        </th>
                        <th class="has-text-centered " width="5%">
                          ຈັດການ
                        </th>
                      </tr>
                      <tr v-if="oarecord_groupdetailcount === 0 && roleid ==28">
                        <th class="has-text-left "  >
                          ຂັ້ນກຸ່ມ
                        </th>
                        <th class="has-text-centered ">
                          <b-field >
                            <b-datepicker
                                    :date-formatter="dateFormatter"
                                    v-model="oarecord_groupdate"
                                    placeholder="ວັນທີ"
                            >
                            </b-datepicker>
                          </b-field>
                        </th>
                        <th class="has-text-centered " >
                          <b-field >
                            <Multiselect
                              placeholder="ເລືອກ"
                              v-model.trim="oarecord_groupstatus"
                              label="NAME"
                              track-by="ID"
                              :options="statusList"
                            >
                            </Multiselect>
                          </b-field>
                        </th>
                        <th class="has-text-centered ">
                          <b-field >
                            <b-input maxlength="200" v-model.trim="oarecord_groupremark"  type="textarea" placeholder="ລາຍລະອຽດ"></b-input>
                          </b-field>
                        </th>
                        <th class="has-text-centered " >
                          <b-field >
                            <button class="button is-info" @click="saveOARecordGroup" >
                              ບັນທຶກ
                            </button>
                          </b-field>
                        </th>
                      </tr>
                      <tr v-if="oarecord_groupdetailcount != 0 ">
                        <th class="has-text-left "  >
                          ຂັ້ນກຸ່ມ
                        </th>
                        <th class="has-text-centered ">
                          <b-field >
                            {{ oarecord_groupdetailcheckdate }}
                          </b-field>
                        </th>
                        <th class="has-text-centered " >
                          <b-field v-if="oarecord_groupdetailstatus==1" class="statusLabel-passed">
                            ຜ່ານ
                          </b-field>
                          <b-field v-if="oarecord_groupdetailstatus==0" class="statusLabel-warning">
                            ບໍ່ຜ່ານ
                          </b-field>
                        </th>
                        <th class="has-text-left ">
                          <b-field >
                            {{ oarecord_groupdetailremark }}
                          </b-field>
                        </th>
                        <th class="has-text-centered " >
                          
                        </th>
                      </tr>
                      <!-- ຂັ້ນເມືອງ -->
                      <tr v-if="oarecord_districtdetailcount === 0 && roleid ==27">
                        <th class="has-text-left "  >
                          ຂັ້ນເມືອງ
                        </th>
                        <th class="has-text-centered ">
                          <b-field >
                            <b-datepicker
                                    :date-formatter="dateFormatter"
                                    v-model="oarecord_districtdate"
                                    placeholder="ວັນທີ"
                            >
                            </b-datepicker>
                          </b-field>
                        </th>
                        <th class="has-text-centered " >
                          <b-field >
                            <Multiselect
                              placeholder="ເລືອກ"
                              v-model.trim="oarecord_districtstatus"
                              label="NAME"
                              track-by="ID"
                              :options="statusList"
                            >
                            </Multiselect>
                          </b-field>
                        </th>
                        <th class="has-text-centered ">
                          <b-field >
                            <b-input maxlength="200" v-model.trim="oarecord_districtremark"  type="textarea" placeholder="ລາຍລະອຽດ"></b-input>
                          </b-field>
                        </th>
                        <th class="has-text-centered " >
                          <b-field >
                            <button class="button is-info" @click="saveOARecordDistrict" >
                              ບັນທຶກ
                            </button>
                          </b-field>
                        </th>
                      </tr>
                      <tr v-if="oarecord_districtdetailcount != 0 && (roleid ==27 || roleid ==26)">
                        <th class="has-text-left "  >
                          ຂັ້ນເມືອງ
                        </th>
                        <th class="has-text-centered ">
                          <b-field >
                            {{ oarecord_districtdetailcheckdate }}
                          </b-field>
                        </th>
                        <th class="has-text-centered " >
                          <b-field v-if="oarecord_districtdetailstatus==1" class="statusLabel-passed">
                            ຜ່ານ
                          </b-field>
                          <b-field v-if="oarecord_districtdetailstatus==0" class="statusLabel-warning">
                            ບໍ່ຜ່ານ
                          </b-field>
                        </th>
                        <th class="has-text-left ">
                          <b-field >
                            {{ oarecord_districtdetailremark }}
                          </b-field>
                        </th>
                        <th class="has-text-centered " >
                          
                        </th>
                      </tr>
                      <!-- ຂັ້ນແຂວງ -->
                      <tr v-if="oarecord_provincedetailcount === 0 && roleid ==26">
                        <th class="has-text-left "  >
                          ຂັ້ນແຂວງ
                        </th>
                        <th class="has-text-centered ">
                          <b-field >
                            <b-datepicker
                                    :date-formatter="dateFormatter"
                                    v-model="oarecord_provincedate"
                                    placeholder="ວັນທີ"
                            >
                            </b-datepicker>
                          </b-field>
                        </th>
                        <th class="has-text-centered " >
                          <b-field >
                            <Multiselect
                              placeholder="ເລືອກ"
                              v-model.trim="oarecord_provincestatus"
                              label="NAME"
                              track-by="ID"
                              :options="statusList"
                            >
                            </Multiselect>
                          </b-field>
                        </th>
                        <th class="has-text-centered ">
                          <b-field >
                            <b-input maxlength="200" v-model.trim="oarecord_provinceremark"  type="textarea" placeholder="ລາຍລະອຽດ"></b-input>
                          </b-field>
                        </th>
                        <th class="has-text-centered " >
                          <b-field >
                            <button class="button is-info" @click="saveOARecordProvince" >
                              ບັນທຶກ 
                            </button>
                          </b-field>
                        </th>
                      </tr>
                      <tr v-if="oarecord_provincedetailcount != 0 && roleid ==26">
                        <th class="has-text-left "  >
                          ຂັ້ນແຂວງ
                        </th>
                        <th class="has-text-centered ">
                          <b-field >
                            {{ oarecord_provincedetailcheckdate }}
                          </b-field>
                        </th>
                        <th class="has-text-centered " >
                          <b-field v-if="oarecord_provincedetailstatus==1" class="statusLabel-passed">
                            ຜ່ານ
                          </b-field>
                          <b-field v-if="oarecord_provincedetailstatus==0" class="statusLabel-warning">
                            ບໍ່ຜ່ານ
                          </b-field>
                        </th>
                        <th class="has-text-left ">
                          <b-field >
                            {{ oarecord_provincedetailremark }}
                          </b-field>
                        </th>
                        <th class="has-text-centered " >
                          
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      
                    </tbody>
                  </table>
                  
                </div>
              </div>
 
            

          </div>
        </b-tab-item>

      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      userName: null,
      roleid: null,

      activeTab: 0,
      districtList: [],
      groupList: [],
      farmList: [],
      productionList: [],
      productionSelected: [],
      oarecordlist: [],
      isDistrictSelected: false,
      isGroupSelected: false,
      isProductionTypeSelected: false,
      isProductionDetailSelected: false,
      selectedDistrictName: "",
      selectedGroupName: "",
      selectedFarmName: "",
      selectedType: "",
      type: "",

      oarecord_groupdate: null,
      oarecord_groupstatus: null,
      oarecord_groupremark: null,
      oarecord_districtdate: null,
      oarecord_districtstatus: null,
      oarecord_districtremark: null,
      oarecord_provincedate: null,
      oarecord_provincestatus: null,
      oarecord_provinceremark: null,

      selectedFarmID : null,
      selectedFarmerID: null,
      selectedcropid : null,

      statusList: [{"ID":"1","NAME":"ຜ່ານ"},{"ID":"0","NAME":"ບໍ່ຜ່ານ"}],

      oarecord_groupdetailcount: null,
      oarecord_groupdetailcheckdate: null,
      oarecord_groupdetailstatus: null,
      oarecord_groupdetailremark: null,

      oarecord_districtdetailcount: null,
      oarecord_districtdetailcheckdate: null,
      oarecord_districtdetailstatus: null,
      oarecord_districtdetailremark: null,

      oarecord_provincedetailcount: null,
      oarecord_provincedetailcheckdate: null,
      oarecord_provincedetailstatus: null,
      
      oarecord_provincedetailremark: null,
      

      // activeSubTab:0,

      // selectedMarketID: null,
      // selectedMarketName: null,
      // marketFarmerList:[],

      // productionReportList: [],
      // productionReportDetail: null,
      // selectedProductionid: null,

      // farmerProductionFarmername: null,
      // farmerProductionRequestID: null,
      // farmerProductionRedate: null,
      // farmerProductionGetplandate: null,
      // farmerProductionID: null,
      // farmerProductionFarmID: null,
      // farmerProductionFarmerID: null,
      // farmerProductionTotalAmount: null,
      // farmerProductionProductid: null,
      // farmerProductionProductname: null,
      // farmerProductionUnit: null,
      // farmerProductionAmount: null,
      // farmerProductionRecommentdate: null,
      // farmerProductionProdate: null,
      // farmerProductionProamount: null,
      // farmerProductionHarvestdate: null,
      // farmerProductionHarvestamount: null,
      // farmerProductionProstatus: null,

      provinceid_of_agrizone_province: null,
      agrizone_provinceid: null,
      agrizone_districtid: null,
      agrizone_groupid: null,
      agrizone_groupname: null,
      section: null,
      agri_data: [],

    };
  },
  methods: {
    getIcsDistrict() {
      // console.log("this.userProvinceID: " + this.userProvinceID)
      RestAPI.getIcsRecordDistrict(this.agrizone_provinceid)
        .then(res => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.districtList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getIcsGroup(data) {
      this.selectedDistrictName= "ເມືອງ: " + data.DISTRICTNAME;
      this.isDistrictSelected= true;
      this.activeTab = 1;
      // console.log("this.userProvinceID: " + this.userProvinceID)
      RestAPI.getIcsRecordGroup(data.ID)
        .then(res => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.groupList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    gotoDistrictlist(){
      this.activeTab = 0;
    },
    gotoGrouplist(){
      this.activeTab = 1;
    },

    gotoFarmlist(){
      this.activeTab = 2;
    },
    gotoProductionlist(){
      this.activeTab = 3;
    },
    getIcsFarm(data) {
      this.selectedGroupName= this.selectedDistrictName+"/ " + data.GROUPNAME;
      this.isGroupSelected= true;
      this.activeTab = 2;
      RestAPI.getIcsRecordFarm(data.ID)
        .then(res => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.farmList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getIcsProduction(data, type) {
      this.type = type;
      this.selectedFarmName= this.selectedGroupName+ "/ " + data.FARMNAME;
      this.isProductionTypeSelected= true;
      this.activeTab = 3;
      RestAPI.getIcsProduction(data.ID, type)
        .then(res => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.productionList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getIcsProductionDetail(data) {
      this.selectedFarmID = data.ID;
      this.selectedFarmerID = data.FARMERID;
      this.selectedcropid = data.MARKETPRODUCTIONID;
      this.oarecord_groupdetail= [];
      this.getOARecordDetail();
      
      if(this.type==1){
        this.selectedType= this.selectedFarmName+ "/ ຜະລິດຕາມຕະຫຼາດ";
      }else if(this.type==2){
        this.selectedType= this.selectedFarmName+ "/ ຜະລິດຕາມສັນຍາ";
      }else{
        this.activeTab=3;
      }
     
      this.isProductionDetailSelected= true;
      this.activeTab = 4;

      RestAPI.getIcsProductionDetail(this.type,this.selectedcropid)
        .then(res => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.productionSelected = res.data.productionSelected;
          this.oarecordlist = res.data.oarecordlist;
          
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getOARecordDetail(){
      RestAPI.getOARecordDetail(this.selectedcropid)
        .then(res => {
          
          // console.log("res.data.group.detail[0]: "+ res.data.group.detail[0])
          
          if(res.data.group.count > 0){
            this.oarecord_groupdetailcount = res.data.group.count;
            this.oarecord_groupdetailcheckdate =  res.data.group.detail[0].GROUPRECORDDATE;
            this.oarecord_groupdetailstatus =  res.data.group.detail[0].GROUPSTATUS;
            this.oarecord_groupdetailremark =  res.data.group.detail[0].GROUPREMARK;
          }else{
            this.oarecord_groupdetailcount = 0;
            this.oarecord_groupdetailcheckdate =  '';
            this.oarecord_groupdetailstatus =  '';
            this.oarecord_groupdetailremark =  '';
          }


          if(res.data.district.count > 0){
            this.oarecord_districtdetailcount = res.data.district.count;
            this.oarecord_districtdetailcheckdate =  res.data.district.detail[0].DISTRICTRECORDDATE;
            this.oarecord_districtdetailstatus =  res.data.district.detail[0].DISTRICTSTATUS;
            this.oarecord_districtdetailremark =  res.data.district.detail[0].DISTRICTREMARK;
          }else{
            this.oarecord_districtdetailcount = 0;
            this.oarecord_districtdetailcheckdate =  '';
            this.oarecord_districtdetailstatus =  '';
            this.oarecord_districtdetailremark =  '';
          }

          if(res.data.province.count > 0){
            this.oarecord_provincedetailcount = res.data.province.count;
            this.oarecord_provincedetailcheckdate =  res.data.province.detail[0].PROVINCERECORDDATE;
            this.oarecord_provincedetailstatus =  res.data.province.detail[0].PROVINCESTATUS;
            this.oarecord_provincedetailremark =  res.data.province.detail[0].PROVINCEREMARK;
          }else{
            this.oarecord_provincedetailcount = 0;
            this.oarecord_provincedetailcheckdate =  '';
            this.oarecord_provincedetailstatus =  '';
            this.oarecord_provincedetailremark =  '';
          }
          
          
        })
        .catch(error => {
          console.log(error); 
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    saveOARecordGroup() {
      if (
        this.oarecord_groupdate === null ||
        this.oarecord_groupstatus === null || 
        this.oarecord_groupremark === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;
      } else {
        var params = {
          famerid: this.selectedFarmerID,
          farmid: this.selectedFarmID,
          cropid: this.selectedcropid,
          recorddate: this.dateFormatterYYYYMMDD(this.oarecord_groupdate),
          groupcheckid: this.username,
          groupstatus: this.oarecord_groupstatus.ID,
          groupremark: this.oarecord_groupremark,
          username: this.username
        };

        // console.log("params:", JSON.stringify(params))
        RestAPI.saveOARecordGroup(params)
          .then(() => {
            this.$swal("ສ້າງຂໍ້ມູນ ສຳເລັດ!", "", "success");
            this.oarecord_groupdate = null;
            this.oarecord_groupstatus = null;
            this.oarecord_groupremark = null;
            this.getOARecordDetail();
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    
    saveOARecordDistrict() {
      if (
        this.oarecord_districtdate === null ||
        this.oarecord_districtstatus === null || 
        this.oarecord_districtremark === null 
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;
      } else {
        var params = {
          cropid: this.selectedcropid,
          recorddate: this.dateFormatterYYYYMMDD(this.oarecord_districtdate),
          districtcheckid: this.username,
          districtstatus: this.oarecord_districtstatus.ID,
          districtremark: this.oarecord_districtremark,
          username: this.username
        };

        console.log("params:", JSON.stringify(params))
        RestAPI.saveOARecordDistrict(params)
          .then(() => {
            this.$swal("ສ້າງຂໍ້ມູນ ສຳເລັດ!", "", "success");
            this.oarecord_distirctdate = null;
            this.oarecord_districtstatus = null;
            this.oarecord_districtremark = null;
            this.getOARecordDetail();
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },

    saveOARecordProvince() {
      if (
        this.oarecord_provincedate === null ||
        this.oarecord_provincestatus === null || 
        this.oarecord_provinceremark === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;
      } else {
        var params = {
          cropid: this.selectedcropid,
          recorddate: this.dateFormatterYYYYMMDD(this.oarecord_provincedate),
          provincecheckid: this.username,
          provincestatus: this.oarecord_provincestatus.ID,
          provinceremark: this.oarecord_provinceremark,
          username: this.username
        };

        // console.log("params:", JSON.stringify(params))
        RestAPI.saveOARecordProvince(params)
          .then(() => {
            this.$swal("ສ້າງຂໍ້ມູນ ສຳເລັດ!", "", "success");
            this.oarecord_provincedate = null;
            this.oarecord_provincestatus = null;
            this.oarecord_provinceremark = null;
            this.getOARecordDetail();
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },


    // getMarketProductionFarmerList(ID, NAME) {
    //   this.selectedMarketID = ID;
    //   this.selectedMarketName = NAME;
    //   console.log("ID:" + ID)
    //   this.activeTab = 1;
    //   this.activeSubTab = 0;
    //   RestAPI.getMarketProductionFarmerList(ID)
    //     .then(res => {
    //       // console.log("list:"+ JSON.stringify(res.data))
    //       this.marketFarmerList = res.data;
    //     })
    //     .catch(error => {
    //       console.log(error);
    //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //     });
    // },


    // getProductionReport(productionid) {
    //   this.activeSubTab=1;
    //   RestAPI.getProductionReport(productionid)
    //     .then(res => {
    //       // console.log("list:"+ JSON.stringify(res.data))
    //       this.productionReportList = res.data;
    //       this.selectedProductionid = productionid;
    //       this.farmerProduction(productionid)
    //     })
    //     .catch(error => {
    //       console.log(error);
    //       this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //     });
    // },
    
    // productionClinicAdvice(){
    //   if(this.productionReportDetail === null || this.productionReportDetail==' '){
    //      this.$swal("ກະລູນາ ລະບຸຄຳແນະນຳ", "", "error");
    //   }else{
    //     // this.selectedProductionid
    //     // console.log("productionReport: " + this.productionReportDetail);

    //     var params = {
    //       productionid: this.selectedProductionid,
    //       detail: this.productionReportDetail,
    //       username: this.username
    //     };
    //     // console.log("params :" + JSON.stringify(params))
    //     RestAPI.productionClinicAdvice(params)
    //     .then(() => {
    //       this.getProductionReport(this.selectedProductionid);
    //       this.productionReportDetail= null;
    //       this.getIcsDistrict();
    //       // this.getMarketProductionFarmerList(this.selectedMarketID, this.selectedMarketName)
     
    //       this.$swal("ສຳເລັດ !", "", "success");
    //     })
    //     .catch(error => {
    //       console.log(error);
    //       if (error == "Error: Request failed with status code 400") {
    //         this.$swal("Check Input Data", "", "error");
    //       } else {
    //         this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
    //       }
    //     });
    //   }
      
    // },

    // farmerProduction(productionid){
    //   RestAPI.getfarmerProduction(productionid)
    //   .then(res => {
    //     this.farmerProductionFarmername =  res.data[0].FARMERNAME;
    //     this.farmerProductionRequestID =  res.data[0].MARKETREQUESTID;
    //     this.farmerProductionID =  res.data[0].PROID;
    //     this.farmerProductionRedate =  res.data[0].REDATE;
    //     this.farmerProductionGetplandate =  res.data[0].GETPLANDATE;
    //     this.farmerProductionFarmID =  res.data[0].FARMID
    //     this.farmerProductionFarmerID =  res.data[0].FARMERID
    //     this.farmerProductionTotalAmount =  res.data[0].TOTALAMOUNT;
    //     this.farmerProductionProductid =  res.data[0].PRODUCTID;
    //     this.farmerProductionProductname =  res.data[0].PRODUCTNAME;
    //     this.farmerProductionUnit =  res.data[0].UNIT;
    //     this.farmerProductionAmount =  res.data[0].AMOUNT;
    //     this.farmerProductionRecommentdate =  res.data[0].RECOMMENTPRODUCEDATE;
    //     this.farmerProductionProdate =  res.data[0].PRODUCEDATE;
    //     this.farmerProductionProamount =  res.data[0].PRODUCEAMOUNT;
    //     this.farmerProductionHarvestdate =  res.data[0].HARVESTDATE;
    //     this.farmerProductionHarvestamount =  res.data[0].HARVESTAMOUNT;
    //     this.farmerProductionProstatus =  res.data[0].PROSTATUS;

    //   })
    //   .catch(error => {
    //     console.log(error);
    //     this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
    //   });
      
    // },
    
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
    getAgrizoneDetail(type,id) {
      RestAPI.getAgrizoneDetail(type,id)
        .then(res => {
          // console.log("getAgrizoneDetail :"+ JSON.stringify(res.data))
          if(type==3){
            this.selectedDistrictName = res.data[0]['PROVINCENAME']+ "/" + res.data[0]['DISTRICTNAME'];
          }else if(type==4){
            this.selectedGroupName= res.data[0]['PROVINCENAME']+ "/" + res.data[0]['DISTRICTNAME'] +"/ " + res.data[0]['GROUPNAME'];
          }

          // this.districtList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    print() {
      window.print();
    }
  },
  mounted() {
    // console.log("this.user.BRANCHPROVNICEID: " + JSON.stringify(this.user));
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.agrizone_provinceid= this.user.AGRIZONE_PROVINCEID ? this.user.AGRIZONE_PROVINCEID : '';
    this.provinceid_of_agrizone_province = this.user.PROINCEID_OF_AGRIZONE_PROVINCE ? this.user.PROINCEID_OF_AGRIZONE_PROVINCE : '';
    this.agrizone_districtid= this.user.AGRIZONE_DISTRICTID ? this.user.AGRIZONE_DISTRICTID : '';
    this.agrizone_districtname= this.user.AGRIZONE_DISTRICTNAME ? this.user.AGRIZONE_DISTRICTNAME : '';
    this.agrizone_groupname= this.user.GROUPNAME ? this.user.GROUPNAME : '';
    this.agrizone_groupid= this.user.GROUPID ? this.user.GROUPID : '';
    this.userProvinceID = this.user.BRANCHPROVNICEID ? this.user.BRANCHPROVNICEID : 'all';

    // console.log("this.user: " + JSON.stringify(this.user));
    // console.log("this.agrizone_groupid: "+ JSON.stringify(this.agrizone_groupid));
    

    this.section =
      this.user.ROLEID == 25
        ? "ສູນກາງ"
        : this.user.ROLEID == 26
        ? "ແຂວງ"
        : this.user.ROLEID == 27
        ? "ເມືອງ"
        : this.user.ROLEID == 28
        ? "ກຸ່ມ"
        : "";
    this.oarecord_groupdate = new Date();
    this.oarecord_distirctdate = new Date();
    this.oarecord_provnicedate = new Date();

     console.log("this.user.ROLEID: "+ this.user.ROLEID)
     console.log("agrizone_provinceid: "+ this.agrizone_provinceid)
     
    if(this.user.ROLEID==26){
      this.getIcsDistrict();
    }
    if(this.user.ROLEID==27){
      this.agri_data['DISTRICTNAME']=this.agrizone_districtname;
      this.agri_data['ID']=this.agrizone_districtid
      this.getAgrizoneDetail(3,this.agrizone_districtid);
      this.getIcsGroup(this.agri_data);
    }else if(this.user.ROLEID==28){
      this.agri_data['GROUPNAME']=this.agrizone_groupname;
      this.agri_data['ID']=this.agrizone_groupid
      //console.log("agri_data-: "+ JSON.stringify(this.agri_data))
      this.getAgrizoneDetail(4,this.agrizone_groupid);
      console.log("this.selectedGroupName: "+ this.selectedGroupName)
      this.getIcsFarm(this.agri_data);
      console.log("this.agrizone_groupid: " + this.agrizone_groupid)
    }
   
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
